import styled from 'styled-components';
import { StyledLegendProps } from './types';
import { baseContainer } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledLegend = styled.ul<StyledLegendProps>`
  display: flex;
  flex-direction: column;

  ${baseContainer}
`;
